import { Box } from "@mui/material";
import React from "react";
import CoreButtonIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonIcon";
import UploadFileRoundedIcon from "@mui/icons-material/UploadFileRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import { t } from "i18next";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import CoreButtonHoverIcon from "../../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import MemoryOutlinedIcon from "@mui/icons-material/MemoryOutlined";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import DocField from "./DocField";

const DocUpload = ({
  selectedFile,
  setSelectedFile,
  processDocument,
  isAIDocumentDataLoading,
  handleReset,
  data,
  docCategory,
  isDocumentDataError,
  dataDoc,
}) => {
  const handleFileDrop = (filesArray) => {
    const file = filesArray[0];
    const isValidFile =
      file.type === "application/pdf" || file.type.startsWith("image/");
    if (!isValidFile) {
      toast.error(t("InvalidFile"));
      return;
    }
    file.type === "application/pdf" && (file.extension = "pdf");
    setSelectedFile(file);
  };

  return (
    <div
      style={{
        border: "1px solid #0000001f",
        height: "87vh",
      }}
      className={`flex flex-col p-2 items-center justify-center rounded-md shadow-md xl:w-5/12 w-full shadow-md" ${
        !selectedFile && "hover:cursor-pointer  hover:bg-hoverInteract"
      } `}
    >
      {data && (
        <DocField
          data={data}
          docCategory={docCategory}
          isDocumentDataError={isDocumentDataError}
          dataDoc={dataDoc}
        />
      )}
      {selectedFile ? (
        <>
          {!data && (
            <TaskOutlinedIcon className="text-gray" sx={{ fontSize: 50 }} />
          )}
          <div>
            <h4 /* className={`${data && "mt-0 mb-2"}`} */>
              {selectedFile.name}
            </h4>
          </div>
          <div className="w-2/3 flex justify-center gap-10 mb-8">
            <CoreButtonHoverIcon
              variant="contained"
              className="m-1"
              icon={<MemoryOutlinedIcon fontSize="small" />}
              testo={t("Process")}
              onClick={processDocument}
              disabled={isAIDocumentDataLoading}
            />
            <CoreButtonHoverIcon
              variant="outlined"
              className="m-1"
              color="error"
              icon={<ClearRoundedIcon fontSize="small" />}
              testo={t("Reset")}
              onClick={handleReset}
              disabled={!selectedFile}
            />
          </div>
        </>
      ) : (
        <Dropzone
          multiple={false}
          onDrop={handleFileDrop}
          accept={["image/*", ".pdf"]}
        >
          {({ getRootProps, getInputProps }) => (
            <div
              className="w-full h-full flex flex-col justify-center items-center gap-16"
              {...getRootProps()}
            >
              <input {...getInputProps()} />
              <p className="text-center text-gray">
                {`${t("DropFile")} (pdf, jpg, png)`}
              </p>
              <Box display="flex" flexDirection="column">
                <CoreButtonIcon
                  icon={
                    <UploadFileRoundedIcon
                      className="text-gray"
                      sx={{ fontSize: 70 }}
                    />
                  }
                />
                <CoreButtonIcon
                  icon={<SearchRoundedIcon className="text-gray" />}
                  testo={t("Search")}
                  className="text-gray"
                />
              </Box>
            </div>
          )}
        </Dropzone>
      )}
    </div>
  );
};

export default DocUpload;
